module.exports = __webpack_public_path__ + "static/media/how-it-works.e31bf1ac.jpg";